// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification {
    background-color: #12871d;
    color: #ffffff;
    padding: 10px;
    margin: 10px;
    border-radius: 5px;
    position: relative;
  }
  
  .close-notification {
    background: none;
    border: none;
    font-size: 16px;
    position: absolute;
    top: 5px;
    right: 10px;
    cursor: pointer;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/excepciones-components/Maintenance/Maintenance-styles/Notification.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;EACjB","sourcesContent":[".notification {\r\n    background-color: #12871d;\r\n    color: #ffffff;\r\n    padding: 10px;\r\n    margin: 10px;\r\n    border-radius: 5px;\r\n    position: relative;\r\n  }\r\n  \r\n  .close-notification {\r\n    background: none;\r\n    border: none;\r\n    font-size: 16px;\r\n    position: absolute;\r\n    top: 5px;\r\n    right: 10px;\r\n    cursor: pointer;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
